<template>
  <div class="relative flex flex-col items-center pyramid-container">
    <img :src="bird" class="pyramid-image mt-2" />

    <div class="absolute labels-container">
      <div class="label number top-1">{{ fatalidades }}</div>
      <div class="label number top-2">{{ acidentesAfastamento }}</div>
      <div class="label number top-3">{{ acidentesSemAfastamento }}</div>
      <div class="label number top-4">{{ incidentes }}</div>
      <div class="label number top-5">{{ relatos }}</div>

      <div class="label text right-1">
        Fatalidade <br />
        <small>(acidente com morte)</small>
      </div>
      <div class="label text right-2">
        Acidentes <br />
        <small>com afastamento</small>
      </div>
      <div class="label text right-3">
        Acidentes <br />
        <small>sem afastamento</small>
      </div>
      <div class="label text right-4">
        Incidentes <br />
        <small>(quase acidentes)</small>
      </div>
      <div class="label text right-5">Desvios</div>
    </div>
  </div>
</template>

<script setup>
import bird from "@/assets/bird.png";
import { dataRcd } from "../../store";
import { computed } from "vue";

const relatos = computed(() => dataRcd.getters.getStatistics?.birdPyramid || 0);
const incidentes = computed(() => Math.round((relatos.value * 3000) / 30000));
const acidentesSemAfastamento = computed(() =>
  Math.round((incidentes.value * 300) / 3000)
);
const acidentesAfastamento = computed(() =>
  Math.round((acidentesSemAfastamento.value * 30) / 300)
);
const fatalidades = computed(() =>
  Math.max(Math.round((acidentesAfastamento.value * 1) / 30))
);
</script>

<style scoped>
.pyramid-container {
  width: 100%;
  max-width: 400px; /* Ajuste o tamanho conforme necessário */
  height: 270px;
}

.pyramid-image {
  width: 100%;
  height: 270px;
}

/* Contêiner das labels */
.labels-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

/* Estilo base dos textos */
.label {
  position: absolute;
  font-weight: bold;
  color: white;
}

/* Números alinhados à esquerda */
.number {
  /* background-color: blue; */
  font-size: 1.2rem;
  text-align: center;
  left: 10%;
  transform: rotate(10deg); /* Inclinação para seguir a pirâmide */
}

/* Labels alinhadas à direita */
.text {
  font-size: 0.78rem;
  text-align: left;
  width: 50%;
}

/* Posicionamento dos números */
.top-1 {
  top: 20%;
  left: 31%;
}
.top-2 {
  top: 32%;
  left: 27%;
}
.top-3 {
  top: 46%;
  left: 23%;
  transform: rotate(15deg);
}
.top-4 {
  top: 60%;
  left: 18%;
  transform: rotate(15deg);
}
.top-5 {
  top: 74%;
  left: 15%;
  transform: rotate(15deg);
}

@media screen and (max-width: 768px) {
  .top-5 {
    top: 76%;
  }
}

/* Posicionamento das labels */
.right-1 {
  top: 5%;
  left: 42%;
}
.right-2 {
  top: 20%;
  left: 49%;
}
.right-3 {
  top: 35%;
  left: 56%;
}
.right-4 {
  top: 50%;
  left: 61%;
  font-size: 0.79rem;
}
.right-5 {
  font-size: 1.2rem;
  top: 67%;
  left: 68%;
}
</style>
